<template>
  <div id="ggu">
    <div class="nav">
      <router-link to="/offer" tag="span">offer龙虎榜</router-link>
      <router-link to="/" tag="span" class="active">学员申请总结</router-link>
    </div>
    <div class="banner">
      <mu-carousel hide-controls>
        <mu-carousel-item v-for="(item, index) in slideImg" :key="index">
          <div @click="goDetails(item.link)">
            <img :src="item.img">
          </div>
        </mu-carousel-item>
      </mu-carousel>
      <!-- <img src="http://www.gguconsulting.com/img/logo.jpg" alt="">
      <p class="explain">本文由世毕盟学员完成，由世毕盟搜集并整理。</p> -->
    </div>
    <div class="tags">
      
      <div class="navList">
        <p :class="currentTab === index?'active':''"v-for="(item, index) in tabs" :key="index" @click="getCurrentTabIndex(index)">
          {{item.name}}
          <span></span>
        </p>
      </div>
      <div v-for="(item, index) in tabs" :key="index">
         <div class="content" v-if="currentTab === index">
            <div class="search" v-if="currentTab != tabs.length">
              <div class="major">
                <button @click="() => major.pop = true" class="search-btn">
                  <span class="search-txt">{{ majorTxt }}</span>
                  <van-icon name="arrow-down" class="icon" />
                </button>
                <van-popup v-model="major.pop" position="bottom" v-if="currentSearch">
                  <van-picker :columns="currentSearch.major" show-toolbar @confirm="majorConfirm" @cancel="majorCancel" />
                </van-popup>
              </div>
              <div class="city">
                <button @click="() => city.pop = true" class="search-btn">
                  <span class="search-txt">{{ cityTxt }}</span>
                  <van-icon name="arrow-down" class="icon" />
                </button>
                <van-popup v-model="city.pop" position="bottom" v-if="currentSearch">
                  <van-picker :columns="currentSearch.city" show-toolbar @confirm="cityConfirm" @cancel="cityCancel" />
                </van-popup>
              </div>
              <div class="search-input-warp">
                <div class="search-input">
                  <input v-model="searchValue" placeholder="关键字查询" />
                </div>
                <div @click="onSearch" class="search-btn blue">搜索</div>
              </div>
            </div>
            <div>
              <van-loading v-show="loading" color="#2663C0" type="spinner" class="loading" />
              <ul class="list">
                <li class="list-item" v-for="(item, index) in list" :key="index">
                  <a :href="item.wx_href">
                    <div class="img">
                      <img v-lazy="imgUrl + item.image">
                    </div>
                    <div class="des-warp">
                      <div class="title">{{ item.log_title }}</div>
                      <div class="des">{{ item.desc }}</div>
                    </div>
                    <!--<div class="new-mes" v-if="item.is_hot == 1">
                      <img src="../../assets/img/new-icon.png"/>
                    </div>-->
                  </a>
                </li>
              </ul>
            </div>
          </div>
      </div>
      <!--<van-tabs v-model="currentTab" sticky swipeable :swipe-threshold="5" color="#2663C0" :line-height="2">
        <van-tab :title="item.name" v-for="(item, index) in tabs" :key="index">
         
        </van-tab>
      </van-tabs>-->
    </div>
  </div>
</template>

<script>
const imgUrl = process.env.VUE_APP_IMAGEURL;
import { cate_list, article_list } from "@/api/index";
export default {
  data() {
    return {
      imgUrl,
      // 专业相关
      major: {
        // 弹框
        pop: false,
        // 选中的
        select: ""
      },
      // 城市相关
      city: {
        // 弹框
        pop: false,
        // 选中的
        select: ""
      },
      // 搜索关键字
      searchValue: "",
      // 搜索数据
      search: {},
      // 案例列表
      list: [],
      // loading
      loading: false,
      // 大分类
      tabs: [
        {
          name: "理科",
          id: "1"
        },
        {
          name: "工科",
          id: "2"
        },
        {
          name: "商科",
          id: "3"
        },
        {
          name: "社科文艺",
          id: "4"
        },
        // {
        //   name: "本科",
        //   id: "5"
        // }
      ],
      currentTab: 0,
      // banner
      slideImg:[{
          img:require('../../assets/img/banner_6.jpg'),
          link:"https://mp.weixin.qq.com/s/MKlvO0C7Lg18ccjwMlPVjQ"
        },{
          img:require('../../assets/img/banner_5.jpg'),
          link:"https://mp.weixin.qq.com/s/9vm1zGgIEkTv9NH2Sh0eGw"
        },
        {
          img:require('../../assets/img/banner_1.jpg'),
          link:"https://mp.weixin.qq.com/s/xdF-bfhj5sAYQKWBk0FUgA"
        },
        // {
        //   img:require('../../assets/img/banner_2.jpg'),
        //   link:"https://mp.weixin.qq.com/s/DbDdb0csx26j1UUX3UR5Sg"
        // },
        {
          img:require('../../assets/img/banner_3.jpg'),
          link:"https://mp.weixin.qq.com/s/S0ZwgyBYWCCs6jZhy4Tdeg"
        },
        {
          img:require('../../assets/img/banner_4.jpg'),
          link:"https://mp.weixin.qq.com/s/FsJqvQi6V-AOjy24p-EFRw"
        }
      ],
      wxImg:"http://www.gguconsulting.com/try/sbm/Public/img/rizhibao_share.jpg"
    };
  },
  computed: {
    // 当前选中的分类ID
    currentTabsId() {
      return this.tabs[this.currentTab].id;
    },
    // 当前搜索数据
    currentSearch: {
      get() {
        return this.search[this.currentTabsId];
      },
      set(value) {
        this.$set(this.search, this.currentTabsId, value);
        return value;
      }
    },
    // 搜专业按钮显示内容
    majorTxt() {
      return this.major.select ? this.major.select.substr(1) : "搜专业";
    },
    // 搜城市按钮显示内容
    cityTxt() {
      return this.city.select
        ? this.currentSearch.city[this.city.select * 1 + 1].text
        : "搜地域";
    }
  },
  methods: {
    // banner
    goDetails(link){
      open(link);
    },
    // 获取分类信息
    async getClassifyData() {
      try {
        let re = await cate_list(this.currentTabsId);
        this.currentSearch = re.data.data;
        this.currentSearch.major = this.currentSearch.cate.map(item => {
          return {
            text: item.selectp,
            select: item.value
          };
        });
        this.currentSearch.major.unshift({
          text: "全部",
          select: ""
        });
        this.currentSearch.city = this.currentSearch.city.map(item => {
          return {
            text: item.region,
            select: item.value
          };
        });
        this.currentSearch.city.unshift({
          text: "全部",
          select: ""
        });
      } catch (error) {
        console.error(error);
      }
    },
    // 获取导航Index
    getCurrentTabIndex(index){
      if(this.currentTab != index){
        this.currentTab = index;
      }
    },
    // 获取列表信息
    async getList() {
      try {
        this.loading = true;
        this.list = [];
        let re = await article_list({
          search: this.currentTabsId,
          selectp: this.major.select,
          region: this.city.select,
          keyword: this.searchValue
        });
        this.list = re.data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    // 专业分类修改
    majorConfirm(value, index) {
      this.major.pop = false;
      this.major.select = value.select;
      this.getList();
    },
    // 专业分类取消
    majorCancel() {
      this.major.pop = false;
    },
    // 城市分类修改
    cityConfirm(value) {
      this.city.pop = false;
      this.city.select = value.select;
      this.getList();
    },
    // 城市分类取消
    cityCancel() {
      this.city.pop = false;
    },
    // 搜索
    onSearch() {
      this.getList();
    }
  },
  watch: {
    async currentTabsId(value) {
      this.major.select = "";
      this.city.select = "";
      this.searchValue = "";
      if (!this.search[value] && value != 5) {
        await this.getClassifyData();
      }
      this.getList();
    }
  },
  async created() {
    await this.getClassifyData();
    this.getList();
    this.WXConfig.wxShowMenu("学员申请经验-世毕盟","快速收藏，海量学长学姐留学申请经验分享","http://www.gguconsulting.com/try/sbm/index.php/#/",this.wxImg);
  }
};
</script>

<style lang="less" scoped>
.mu-carousel {
  height: 330px;
  img {
    height: 100%;
    width: 100%;
  }
  /deep/ .mu-carousel-indicators{
    height:60px;
  }
  /deep/ .mu-carousel-indicator-button{
    width:12px;
    height:12px;
  }
  /deep/ .mu-carousel-indicator-icon{
    width:12px;
    height:12px;
  }
}
.banner {
  padding: 17px;
  padding-bottom: 0;
  position: relative;
  .explain {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 40px;
    font-size: 30px;
    color: #fff;
    text-align: center;
    font-weight: 900;
  }
}

.content {
  padding: 30px;
}

.search {
  .flex();
}

.search-input-warp {
  .flex();
}

.list {
  .list-item {
    padding-top: 30px;
    position: relative;
    .new-mes {
      position: absolute;
      right: -20px;
      top: 44px;
      width: 60px;
      height: auto;
      img {
        width: 100%;
      }
    }
    a {
      .flex();
    }
    .img {
      height: 150px;
      width: 150px;
      // border:1px solid #efefef;
      // box-sizing:border-box;
      img {
        width: 150px;
        
      }
    }
    &:first-child {
      .des-warp {
        .title {
          width: 460px;
        }
      }
    }
    .des-warp {
      width: 500px;
      padding-bottom: 30px;
      .mix-1px-bottom(#e6e6e6);
      .title {
        font-size: 30px;
        color: #323232;
        .mix-text-overflow();
        padding-top: 10px;
      }
      .des {
        padding-top: 10px;
        font-size: 24px;
        color: #949494;
        line-height: 36px;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        box-orient: vertical;
        -webkit-box-orient: vertical;
      }
    }
  }
}

.search-btn {
  line-height: 60px;
  height: 60px;
  color: #a8a8a8;
  font-size: 26px;
  border-radius: 3px;
  padding: 0 15px;
  box-sizing: border-box;
  background: none;
  text-align: left;
  position: relative;
  border: none;
  .mix-1px-all(#e6e6e6, 3px);
  &.blue {
    border: 1px solid @blue;
    .mix-1px-none();
    color: @blue;
  }
  .icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.search-txt {
  height: 100%;
  line-height: 60px;
  width: 140px;
  .mix-text-overflow();
  display: block;
}

.search-input {
  padding: 0;
  width: 182px;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  margin-right: 14px;
  border-radius: 3px;
  font-size: 26px;
  .mix-1px-all(#e6e6e6, 3px);
  input {
    border: none;
  }
}

.loading {
  margin: 0 auto;
  margin-top: 200px;
}
.tags{
  .navList{
    display:flex;
    margin-top:10px;
    border-bottom:1px solid #e6e6e6;
    p{
      flex:1;
      text-align:center;
      font-size: 26px;
      padding:20px 0;
      position:relative;
      span{
        position:absolute;
        bottom:0px;
        left:50%;
        transform:translateX(-50%);
        width:70px;
        height:2px;
        background:transparent;
      }
      &.active{
        color: @blue;
        font-weight: 600;
        span{
          background: @blue;
        }
      }
    }
  }
}
.tags /deep/ .van-tab--active {
  color: @blue;
  font-weight: 600;
}

.tags /deep/ .van-icon {
  vertical-align: middle;
}

.tags /deep/ .van-search {
  background: none !important;
}

.tags /deep/ .van-picker__cancel {
  color: @blue;
}

.tags /deep/ .van-picker__confirm {
  color: @blue;
}

.tags /deep/ .van-hairline--top-bottom {
  &::after {
    border-width: 0 0 1PX 0
  }
}
//nav
.nav {
  height:90px;
  border-bottom:1px solid #E6E6E6;

  span{
    font-size:32px;
    color:#192533;
    width:50%;
    text-align:center;
    line-height:90px;
    display: inline-block;
    font-weight:600;
  }
  .active{
    color:#2a62d1;
    position:relative;
  }
  .active:before{
    border-bottom: 5px solid #2a62d1;
    bottom: 0;
    content: "";
    display: inline-block;
    left: calc(50% - 25px);
    position: absolute;
    width: 50px;
  }
}
</style>
